var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.999,
    height: 12,
    viewBox: "0 0 12.999 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-2{fill:#e11e24}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    fill: "#ffffff",
    d: "M11.7 12H1.3a1.3 1.3 0 0 1-1.124-.67 1.389 1.389 0 0 1 0-1.342l5.2-9.317a1.277 1.277 0 0 1 2.248 0l5.2 9.316a1.386 1.386 0 0 1 0 1.342A1.3 1.3 0 0 1 11.7 12zM6.5 1.342l-5.2 9.316h10.4L6.5 1.342z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0 .671v2.8a.66.66 0 0 0 .649.671.66.66 0 0 0 .651-.671v-2.8A.66.66 0 0 0 .649 0 .66.66 0 0 0 0 .671z",
    className: "cls-2",
    transform: "translate(6 3.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    d: "M1.3.671a.649.649 0 1 1-1.3 0 .649.649 0 1 1 1.3 0",
    className: "cls-2",
    transform: "translate(6 8)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSelected);
export default __webpack_public_path__ + "static/media/alertSelected.c0cbfb1b871066520a2506a14fbb72dd.svg";
export { ForwardRef as ReactComponent };